import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environment';
import { AuthService } from '@common/services/AuthService/AuthService';
import { ClientsData } from '@common/models/clientsData.model';
import { ClientDetails } from '@common/models/clientDetails.model';
import { QueryParameters } from '@common/models/queryParameters.model';
import { QueryParametersStringified } from '@common/models/queryParametersStringified.model';

@Injectable()
export class ClientService {
  constructor(
    private http: HttpClient,
    public authService: AuthService,
  ) {}

  getClients(queryParameters: QueryParameters): Observable<ClientsData> {
    const endpoint = environment.endpoints.clients;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    const params: QueryParametersStringified = {
      query: queryParameters.query,
      orderBy: queryParameters.orderBy,
      sortOrder: queryParameters.sortOrder,
      page: queryParameters.page.toString(),
    };

    return this.http.get<ClientsData>(
      `${endpoint}${companyKey}/`,
      {
        params,
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  getClientDetails(clientKey: string): Observable<ClientDetails> {
    const endpoint = environment.endpoints.clientDetails;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.get<ClientDetails>(
      `${endpoint}${companyKey}/${clientKey}/`,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/ClientService/ClientService.ts